import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getInstanceList = store => store[NAME].instanceList;
export const getTypeList = store => store[NAME].typeList;
